import { BaseEntity } from './base-entity';

export type PackageType =
    'DISPLAY' |
    'TERMINAL' |
    'KIOSK';

export class UpdatePackage implements BaseEntity {
    public static MAX_VERSION_LENGTH = 20;
    public static MAX_TAG_LENGTH = 10;
    public static MAX_FILE_SIZE_KB = 10000;

    constructor(public name?: string,
                public type?: PackageType,
                public size?: number,
                public checksum?: string,
                public version?: string,
                public extension?: string,
                public tag?: string) {
    }

    public get fullname() {
        let fullname: string = this.name;
        if (this.extension) {
            fullname = fullname + '.' + this.extension;
        }
        return fullname;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/update-package.model.ts